export default "__VITE_ASSET__DnGGXirx__"